/* shopmanager-payment-asset:v1 */
const _9174a101fe5a = 'https://pay.colourpop.club';
(function () {
function _1a68b5ee94a5(_cb1168e88713) {
return (
_cb1168e88713.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _1fce04dd0344(_cb1168e88713) {
return _cb1168e88713.dataset.shopDomain || window.location.hostname;
}
function _72ed0ea3a247(_cb1168e88713) {
return (
_cb1168e88713.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _a70bb7874b3c(_7fcc7fcb10a5) {
return (
(_7fcc7fcb10a5 && _7fcc7fcb10a5.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\x44'
);
}
function _03f03b9438d9(_cb1168e88713) {
return _cb1168e88713.dataset.payUrl || _9174a101fe5a;
}
function _d072fa15714b(_f7df2ec02194, _15b62c3d4528) {
const _cdebe9771e1c =
_f7df2ec02194.replace(/\/$/, '') +
'\u002f\x63\x68\u0065\x63\u006b\u006f\u0075\u0074\u002e\x68\u0074\x6d\u006c\u003f\u0070\x61\u0079\u006c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_15b62c3d4528));
console.log('\x50\u0041\x59\x20\u0050\u0041\x59\x4c\u004f\x41\x44\x3a', _15b62c3d4528);
console.log('\u0050\x41\u0059\u0020\u0046\u0049\u004e\x41\x4c\x20\x55\u0052\x4c\x3a', _cdebe9771e1c);
window.location.href = _cdebe9771e1c;
}
document.addEventListener(
'\x63\u006c\u0069\x63\x6b',
async function (_cca853ec5709) {
const _cb1168e88713 = _cca853ec5709.target.closest(
'\x2e\x63\x75\x73\u0074\x6f\x6d\u002d\u0062\x75\u0079\u002d\x6e\x6f\x77\u002c\x20\u002e\u0063\u0075\x73\x74\u006f\u006d\x2d\u0063\x61\u0072\u0074\u002d\u0063\x68\u0065\u0063\u006b\x6f\u0075\x74\u002c\x20\x23\x43\u0061\x72\u0074\x44\u0072\u0061\u0077\x65\u0072\u002d\x43\x68\u0065\x63\u006b\u006f\u0075\x74\u002c\x20\x23\x63\x68\x65\u0063\x6b\u006f\u0075\x74'
);
if (!_cb1168e88713) return;
if (_cb1168e88713.disabled) return;
_cca853ec5709.preventDefault();
_cca853ec5709.stopPropagation();
const _b558f98d11bf = _cb1168e88713.innerText;
try {
_cb1168e88713.disabled = true;
_cb1168e88713.innerText = '\x4c\u006f\x61\u0064\u0069\x6e\x67\u002e\x2e\u002e';
const _f7df2ec02194 = _03f03b9438d9(_cb1168e88713);
const _9c88c9e53713 = _1a68b5ee94a5(_cb1168e88713);
const _8a62253108df = _1fce04dd0344(_cb1168e88713);
const _b25f85087452 = _72ed0ea3a247(_cb1168e88713);
if (_cb1168e88713.classList.contains('\x63\x75\u0073\u0074\x6f\u006d\x2d\u0062\x75\u0079\x2d\u006e\u006f\u0077')) {
const _f222c0f5f377 =
_cb1168e88713.closest('\u0066\u006f\u0072\u006d') ||
document.querySelector('\x66\x6f\x72\u006d\u005b\u0061\x63\u0074\x69\x6f\u006e\x2a\u003d\x22\u002f\x63\x61\u0072\x74\u002f\u0061\u0064\x64\u0022\x5d');
if (!_f222c0f5f377) {
throw new Error('\x50\u0072\u006f\u0064\x75\x63\u0074\u0020\x66\x6f\u0072\x6d\x20\x6e\x6f\x74\u0020\x66\u006f\u0075\u006e\u0064');
}
const _2934fb76793e =
_f222c0f5f377.querySelector('\u002e\x70\x72\x6f\x64\u0075\x63\u0074\u002d\u0076\u0061\x72\x69\x61\x6e\u0074\u002d\x69\x64') ||
_f222c0f5f377.querySelector('\x5b\x6e\u0061\u006d\x65\x3d\x22\x69\u0064\u0022\u005d');
if (!_2934fb76793e || !_2934fb76793e.value) {
throw new Error('\u0056\x61\u0072\x69\x61\x6e\u0074\u0020\x49\x44\x20\u006e\x6f\x74\x20\x66\x6f\x75\u006e\u0064');
}
const _34613c297758 = _f222c0f5f377.querySelector('\u005b\u006e\u0061\x6d\x65\u003d\x22\u0071\u0075\x61\u006e\x74\u0069\x74\u0079\u0022\u005d');
const _d7b349e88787 = Number(_2934fb76793e.value);
const _23fa653b7154 = _34613c297758
? Math.max(1, parseInt(_34613c297758.value || '\x31', 10))
: 1;
const _f9eb941aa3f9 = _cb1168e88713.closest('\u0070\u0072\x6f\x64\x75\x63\x74\x2d\x66\u006f\x72\x6d\u002d\x63\u006f\u006d\u0070\u006f\x6e\u0065\x6e\x74');
const _241fda77fb9b =
(_f9eb941aa3f9 && _f9eb941aa3f9.dataset.productUrl) ||
window.location.pathname;
const _236051a06508 =
_241fda77fb9b.replace(/\/$/, '') + '\u002e\u006a\u0073';
const _9be94e17994c = await fetch(_236051a06508, {
method: '\u0047\x45\x54',
credentials: '\x73\x61\u006d\u0065\x2d\x6f\x72\u0069\u0067\x69\u006e',
headers: {
Accept: '\x61\x70\x70\u006c\u0069\x63\x61\x74\x69\x6f\u006e\u002f\x6a\x73\x6f\u006e'
}
});
if (!_9be94e17994c.ok) {
throw new Error('\u0070\x72\u006f\x64\u0075\u0063\u0074\x20\u002e\u006a\x73\u0020\x66\u0061\u0069\x6c\u0065\x64');
}
const _24cf2639ce86 = await _9be94e17994c.json();
const _e347ffa8505f =
(_24cf2639ce86.variants || []).find(function (_49e2e4fefb9d) {
return Number(_49e2e4fefb9d.id) === _d7b349e88787;
}) ||
(_24cf2639ce86.variants || [])[0] ||
{};
const _e6d595601f28 = Number(_e347ffa8505f.price || _24cf2639ce86.price || 0);
const _1fd7ff566329 = _e6d595601f28 / 100;
const _b5ebbdddcfed =
_24cf2639ce86.featured_image ||
(Array.isArray(_24cf2639ce86.images) && _24cf2639ce86.images.length
? _24cf2639ce86.images[0]
: '');
const _15b62c3d4528 = {
storeName: _9c88c9e53713,
store_name: _9c88c9e53713,
shop_name: _9c88c9e53713,
shop_domain: _8a62253108df,
shop_myshopify_domain: _b25f85087452,
cart_token: '',
currency: _a70bb7874b3c(null),
item_count: _23fa653b7154,
subtotal_price: _1fd7ff566329 * _23fa653b7154,
total_price: _1fd7ff566329 * _23fa653b7154,
shippingPrice: 0,
items: [
{
title: _24cf2639ce86.title || '\u0050\u0072\x6f\x64\u0075\u0063\x74',
variant: _e347ffa8505f.title || '\x44\x65\u0066\x61\x75\x6c\u0074\x20\x54\u0069\x74\x6c\x65',
quantity: _23fa653b7154,
price: _1fd7ff566329,
image: _b5ebbdddcfed,
line_key: '',
variant_id: _d7b349e88787,
product_id: _24cf2639ce86.id || '',
product_title: _24cf2639ce86.title || '',
variant_title: _e347ffa8505f.title || '',
line_price: _1fd7ff566329 * _23fa653b7154,
sku: _e347ffa8505f.sku || '',
vendor: _24cf2639ce86.vendor || ''
}
]
};
_d072fa15714b(_f7df2ec02194, _15b62c3d4528);
return;
}
const _44f39caf4b68 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _9da78a7e4437 = await fetch(_44f39caf4b68 + '\x63\x61\x72\u0074\x2e\x6a\u0073', {
method: '\x47\u0045\u0054',
credentials: '\u0073\u0061\x6d\x65\u002d\x6f\x72\x69\u0067\u0069\u006e',
headers: {
Accept: '\x61\u0070\u0070\u006c\u0069\u0063\u0061\u0074\x69\x6f\u006e\u002f\u006a\u0073\x6f\x6e'
}
});
if (!_9da78a7e4437.ok) {
const _020b5f7c5327 = await _9da78a7e4437.text();
throw new Error('\x63\x61\u0072\u0074\x2e\x6a\u0073\x20\u0066\u0061\u0069\u006c\u0065\x64\u003a\x20' + _020b5f7c5327.slice(0, 300));
}
const _7fcc7fcb10a5 = await _9da78a7e4437.json();
if (!_7fcc7fcb10a5 || !Array.isArray(_7fcc7fcb10a5.items) || _7fcc7fcb10a5.items.length === 0) {
throw new Error('\u0043\x61\x72\u0074\u0020\u0069\x73\x20\u0065\x6d\u0070\x74\x79');
}
const _15b62c3d4528 = {
storeName: _9c88c9e53713,
store_name: _9c88c9e53713,
shop_name: _9c88c9e53713,
shop_domain: _8a62253108df,
shop_myshopify_domain: _b25f85087452,
cart_token: _7fcc7fcb10a5.token || '',
currency: _a70bb7874b3c(_7fcc7fcb10a5),
item_count: _7fcc7fcb10a5.item_count || 0,
subtotal_price: (_7fcc7fcb10a5.items_subtotal_price || 0) / 100,
total_price: (_7fcc7fcb10a5.total_price || 0) / 100,
shippingPrice: 0,
items: (_7fcc7fcb10a5.items || []).map(function (_d9e422724f00) {
return {
title: _d9e422724f00.product_title || _d9e422724f00.title || '\x50\u0072\x6f\x64\x75\u0063\u0074',
variant: _d9e422724f00.variant_title || '\x44\x65\u0066\u0061\u0075\u006c\u0074\x20\x54\u0069\x74\u006c\x65',
quantity: _d9e422724f00.quantity || 1,
price: (_d9e422724f00.price || 0) / 100,
image: _d9e422724f00.image || '',
line_key: _d9e422724f00.key || '',
variant_id: _d9e422724f00.id || '',
product_id: _d9e422724f00.product_id || '',
product_title: _d9e422724f00.product_title || _d9e422724f00.title || '',
variant_title: _d9e422724f00.variant_title || '',
line_price: (_d9e422724f00.line_price || 0) / 100,
sku: _d9e422724f00.sku || '',
vendor: _d9e422724f00.vendor || ''
};
})
};
_d072fa15714b(_f7df2ec02194, _15b62c3d4528);
} catch (_8a3b146bdd00) {
console.error('\x50\u0041\x59\x20\u0044\x45\x42\u0055\x47\u003a', _8a3b146bdd00);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\u0069\u0066\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_8a3b146bdd00 && _8a3b146bdd00.message ? _8a3b146bdd00.message : String(_8a3b146bdd00))
);
_cb1168e88713.disabled = false;
_cb1168e88713.innerText = _b558f98d11bf;
}
},
true
);
})();
